// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M4 4L8 8M12 4L8 8M12 12L8 8M4 12L8 8'];
